webpackJsonp([24],{

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GruposDisponiblesPage_vue_vue_type_template_id_4bf2858b_scoped_true___ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GruposDisponiblesPage_vue_vue_type_script_lang_js___ = __webpack_require__(541);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__ = __webpack_require__(16);





/* normalize component */

var component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_componentNormalizer_js__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_1__GruposDisponiblesPage_vue_vue_type_script_lang_js___["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_0__GruposDisponiblesPage_vue_vue_type_template_id_4bf2858b_scoped_true___["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_0__GruposDisponiblesPage_vue_vue_type_template_id_4bf2858b_scoped_true___["b" /* staticRenderFns */],
  false,
  null,
  "4bf2858b",
  null
  
)

/* harmony default export */ __webpack_exports__["default"] = (component.exports);

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GruposDisponiblesPage_vue_vue_type_script_lang_js___ = __webpack_require__(542);
/* unused harmony namespace reexport */
 /* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__node_modules_babel_loader_lib_index_js_node_modules_vue_loader_lib_index_js_vue_loader_options_GruposDisponiblesPage_vue_vue_type_script_lang_js___["a" /* default */]); 

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GruposDisponiblesPage',
  mounted: function mounted() {
    this.getGruposDisponibles();
  },
  data: function data() {
    return {
      cargandoDatos: true,
      headers: [{
        text: 'Materia',
        align: 'left',
        value: 'nombre'
      }, {
        text: 'Gpo',
        value: 'grupo'
      }, {
        text: 'Cr',
        value: 'creditos'
      }, {
        text: 'Lunes',
        value: 'lunes'
      }, {
        text: 'Martes',
        value: 'martes'
      }, {
        text: 'Miércoles',
        value: 'miercoles'
      }, {
        text: 'Jueves',
        value: 'jueves'
      }, {
        text: 'Viernes',
        value: 'viernes'
      }, {
        text: 'Sábado',
        value: 'sabado'
      }, {
        text: 'Domingo',
        value: 'domingo'
      }],
      grupos: [],
      fueraDeTiempo: false
    };
  },
  methods: {
    getGruposDisponibles: function getGruposDisponibles() {
      var _this = this;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('alumno/grupos-disponibles?listar-grupos=1').then(function (request) {
        _this.grupos = request.data.grupos;
        _this.fueraDeTiempo = request.data.fueraDeTiempo;
      }).finally(function () {
        _this.cargandoDatos = false;
      });
    },
    formatoHorario: function formatoHorario(item) {
      return item === '' ? '' : item.horaInicial + '-' + item.horaFinal + '/' + item.aula;
    }
  }
});

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_GruposDisponiblesPage_vue_vue_type_template_id_4bf2858b_scoped_true___ = __webpack_require__(670);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_GruposDisponiblesPage_vue_vue_type_template_id_4bf2858b_scoped_true___["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_loaders_templateLoader_js_ref_1_node_modules_vue_loader_lib_index_js_vue_loader_options_GruposDisponiblesPage_vue_vue_type_template_id_4bf2858b_scoped_true___["b"]; });


/***/ }),

/***/ 670:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',[_c('v-flex',{attrs:{"md12":""}},[_c('v-card',[_c('v-card-title',[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v("Grupos Disponibles")])])]),_vm._v(" "),(!_vm.fueraDeTiempo)?_c('v-card-text',[(_vm.$mq !== 'sm')?_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.grupos,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('strong',[_vm._v(_vm._s(props.item.nombre))]),_c('br'),_vm._v("\n                                "+_vm._s(props.item.clave)+" "),_c('br'),_vm._v("\n                                "+_vm._s(props.item.docente)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.grupo))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.creditos))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatoHorario(props.item.horario[2])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatoHorario(props.item.horario[3])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatoHorario(props.item.horario[4])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatoHorario(props.item.horario[5])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatoHorario(props.item.horario[6])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatoHorario(props.item.horario[7])))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatoHorario(props.item.horario[1])))])]}}],null,false,3963646092)}):(_vm.$mq === 'sm')?_c('v-data-iterator',{attrs:{"items":_vm.grupos,"rows-per-page-items":[10],"content-tag":"v-layout","row":"","wrap":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('v-card',[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h4',[_vm._v(_vm._s(props.item.nombre))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(props.item.clave))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(props.item.docente))])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Grupo:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.grupo))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Creditos:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.creditos))])],1),_vm._v(" "),(props.item.horario[2])?_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Lunes:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm.formatoHorario(props.item.horario[2])))])],1):_vm._e(),_vm._v(" "),(props.item.horario[3])?_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Martes:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm.formatoHorario(props.item.horario[3])))])],1):_vm._e(),_vm._v(" "),(props.item.horario[4])?_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Miércoles:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm.formatoHorario(props.item.horario[4])))])],1):_vm._e(),_vm._v(" "),(props.item.horario[5])?_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Jueves:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm.formatoHorario(props.item.horario[5])))])],1):_vm._e(),_vm._v(" "),(props.item.horario[6])?_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Viernes:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm.formatoHorario(props.item.horario[6])))])],1):_vm._e(),_vm._v(" "),(props.item.horario[7])?_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Sábado:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm.formatoHorario(props.item.horario[7])))])],1):_vm._e(),_vm._v(" "),(props.item.horario[1])?_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Domingo:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm.formatoHorario(props.item.horario[1])))])],1):_vm._e()],1)],1)],1)}}],null,false,956619149)}):_vm._e()],1):_c('v-card-text',[_vm._v("\n                    El proceso de reinscripción se encuentra cerrado.\n                ")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"280px","persistent":""},model:{value:(_vm.cargandoDatos),callback:function ($$v) {_vm.cargandoDatos=$$v},expression:"cargandoDatos"}},[_c('v-card',[_c('v-card-title',[_c('v-progress-circular',{attrs:{"size":50,"indeterminate":"","color":"primary"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',[_vm._v("Cargando horario de clases")])],1)],1)],1)],1)],1)
}
var staticRenderFns = []



/***/ })

});


// WEBPACK FOOTER //
// static/js/24.ed599afc3499836c47f8.js